
import { TrackingKey } from '../../../types';

export const tracking: Record<TrackingKey, string> = {
  pixel: 'Pixel',
  enablePixel: 'Ativar Pixel',
  pixelId: 'ID do Pixel',
  pixelType: 'Tipo de Pixel',
  selectPixelType: 'Selecionar Tipo de Pixel',
  other: 'Outro',
  triggerEvent: 'Evento de Disparo',
  selectEvent: 'Selecionar Evento',
  onPlay: 'Ao Reproduzir',
  onPause: 'Ao Pausar',
  at25Percent: 'Aos 25% Visualizados',
  at50Percent: 'Aos 50% Visualizados',
  at100Percent: 'Aos 100% Visualizados',
  affiliates: 'Afiliados',
  enableAffiliateTracking: 'Ativar Rastreamento de Afiliados',
  affiliateId: 'ID do Afiliado',
  vslDynamic: 'VSL Dynamic',
  vsleads: 'VSLeads',
  abTest: 'Teste A/B',
  hookTrack: 'Teste de hook',
  'pixel.header.title': 'Rastreamento com Pixel',
  'pixel.header.subtitle': 'Monitore conversões e eventos importantes do seu vídeo com pixels de rastreamento',
  'pixel.enable.helper': 'Ative para rastrear eventos e conversões em plataformas de anúncios',
  'pixel.type.helper': 'Escolha a plataforma de anúncios que deseja integrar',
  'pixel.id.helper': 'Cole o ID do pixel fornecido pela plataforma de anúncios',
  'pixel.configure': 'Configurar Integração',
  'pixel.edit': 'Editar Configuração',
  'pixel.token': 'Token',
  'pixel.token.placeholder': 'Digite seu token...',
  'pixel.token.helper': 'Token de acesso fornecido pelo Facebook',
  'pixel.siteUrl': 'Site URL',
  'pixel.siteUrl.placeholder': 'https://seusite.com',
  'pixel.siteUrl.helper': 'URL do site onde o pixel será instalado',
  'pixel.siteUrl.error': 'O URL deve iniciar com https://',
  'pixel.selectVideo': 'Selecione o Vídeo',
  'pixel.selectVideo.placeholder': 'Escolha o vídeo a integrar',
  'pixel.modal.title': 'Configurar integração com Facebook',
  'pixel.modal.help': 'Precisa de ajuda? Clique aqui',
  'pixel.modal.cancel': 'Cancelar',
  'pixel.modal.save': 'SALVAR',
  'pixel.modal.saving': 'Salvando...',
  'pixel.success': 'Integração configurada com sucesso',
  'pixel.configured': 'Integração configurada com sucesso',
  
  // Affiliate
  'affiliate.header.title': 'Afiliados',
  'affiliate.header.subtitle': 'Configure seu link de afiliado e ganhe comissões quando novos usuários se cadastrarem.',
  'affiliate.enable': 'Ativar link de afiliado',
  'affiliate.enable.helper': 'Exibe a logo da HostVSL no player e ativa o redirecionamento pelo seu link',
  'affiliate.url.label': 'Seu link de afiliado',
  'affiliate.url.placeholder': 'https://hostvsl.com/?ref=SEU_ID',
  'affiliate.url.helper': 'Insira seu link de afiliado para ganhar comissões. A logo da HostVSL ficará disponível no canto superior direito do player e, ao clicar nela, seu link de afiliado será aberto em uma nova aba.',
  'affiliate.url.required': 'O link de afiliado é obrigatório quando o recurso está ativado.',
  'affiliate.url.invalid': 'Informe um link válido iniciando com http:// ou https://.',
  'affiliate.url.validation': 'Parece que este link não é válido. Verifique e tente novamente.',
  'affiliate.advanced': 'Opções avançadas',
  'affiliate.showOnMobile': 'Exibir logo também no mobile',
  'affiliate.hoverOpacity': 'Opacidade ao passar o mouse',
  'affiliate.displayDelay': 'Aparecer após iniciar o vídeo',
  'affiliate.delay.immediate': 'Imediato'
};
